module.exports = __webpack_public_path__ + "img/logo.6fc01a6f.png";